import React, { useCallback } from 'react'
import { toast } from 'react-toastify'
import { CloseButton } from 'reactstrap'

const TOAST_CONFIG = {
  position: 'top-right',
  autoClose: true,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: false,
  closeButton: <CloseButton />
}

export const useToast = () => {
  const showSuccess = useCallback((message) => {
    toast.success(message, TOAST_CONFIG)
  }, [])

  const showError = useCallback((message) => {
    toast.error(message, TOAST_CONFIG)
  }, [])

  return { showSuccess, showError }
}
